import {
  CardFooter,
  Alert,
  AlertIndicator,
  AlertContent,
  AlertTitle,
  AlertDescription,
  Chip,
} from "@heroui/react";
import type { Campaign } from "../model/types";

export interface CampaignCardFooterProps {
  campaign: Campaign;
}

export const CampaignCardFooter = ({ campaign }: CampaignCardFooterProps) => {
  const problems = campaign.problems || [];
  const activeRules =
    campaign.active_rules?.filter((r) => r.is_enabled).map((r) => r.name) ||
    campaign.activeModules ||
    [];

  if (problems.length > 0) {
    return (
      <CardFooter className="pt-0 flex flex-col gap-2">
        {problems.map((problem, pIdx) => (
          <Alert
            key={pIdx}
            status="danger"
            className="w-full rounded-xl bg-rose-500/10 border border-rose-500/30"
          >
            <AlertIndicator />
            <AlertContent>
              <AlertTitle className="text-xs font-semibold text-rose-400">
                {problem.module_name} ({problem.entities_count} неэфф. площадок)
              </AlertTitle>
              <AlertDescription className="text-xs">
                {problem.description}
              </AlertDescription>
            </AlertContent>
          </Alert>
        ))}
      </CardFooter>
    );
  }

  if (activeRules.length > 0) {
    return (
      <CardFooter className="pt-0">
        {activeRules.map((rule, rIdx) => (
          <Chip color="accent" variant="primary">
            {rule}
          </Chip>
        ))}
      </CardFooter>
    );
  }

  return null;
};
